import { render, staticRenderFns } from "./RoleEditorModal.vue?vue&type=template&id=0110f917&scoped=true&"
import script from "./RoleEditorModal.vue?vue&type=script&lang=js&"
export * from "./RoleEditorModal.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditorModal.vue?vue&type=style&index=0&id=0110f917&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110f917",
  null
  
)

export default component.exports